import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType, SpecyficType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { DressingBodyToSimpleSapElementMapper } from './dressingBodyToSimpleSapElementMapper';
import { HandleToSimpleSapElementMapper } from '../handleToSimpleSapElementMapper';
import { DressingDrawerToSimpleSapElementMapper } from './dressingDrawerToSimpleSapElementMapper';
import { DressingLegsToSimpleSapElementMapper } from './dressingLegsToSimpleSapElementMapper';
import { DressingWallToSimpleSapElementMapper } from './dressingWallToSimpleSapElementMapper';
import { DressingFrontToSimpleSapElementMapper } from './dressingFrontToSimpleSapElementMapper';

export class DressingElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new DressingBodyToSimpleSapElementMapper();
    private front = new DressingFrontToSimpleSapElementMapper();
    private drawer = new DressingDrawerToSimpleSapElementMapper();
    private wall = new DressingWallToSimpleSapElementMapper();
    private handle = new HandleToSimpleSapElementMapper();
    private legs = new DressingLegsToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.FRONT) {
            return this.front;
        }
        if (element.specyficType === SpecyficType.DRAWER) {
            return this.drawer;
        }
        if (element.type === ElementType.WALL) {
            return this.wall;
        }
        if (element.type === ElementType.HANDLE) {
            return this.handle;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        return this.null;
    }
}